import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SITE_URL } from '../../seo/siteUrl';

const DEFAULT_OG_IMAGE = `${SITE_URL}/logo.png`;

/**
 * SEO head: canonical URL, title/description, Open Graph, Twitter, optional JSON-LD.
 */
export default function SeoHead({
  title,
  description,
  canonicalPath,
  noindex,
  ogImage,
  jsonLdScripts = [],
}) {
  const path =
    typeof window !== 'undefined'
      ? window.location.pathname + window.location.search
      : canonicalPath || '/';

  const canonical =
    canonicalPath != null
      ? `${SITE_URL}${canonicalPath.startsWith('/') ? canonicalPath : `/${canonicalPath}`}`
      : `${SITE_URL}${path}`;

  const pageTitle = title != null ? title : 'Proppins';
  const pageDesc = description != null ? description : '';
  const imageUrl = ogImage || DEFAULT_OG_IMAGE;
  const scripts = Array.isArray(jsonLdScripts) ? jsonLdScripts.filter(Boolean) : [];

  return (
    <Helmet>
      <link rel="canonical" href={canonical} />
      <title>{pageTitle}</title>
      {pageDesc ? <meta name="description" content={pageDesc} /> : null}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Proppins" />
      <meta property="og:title" content={pageTitle} />
      {pageDesc ? <meta property="og:description" content={pageDesc} /> : null}
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={imageUrl} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      {pageDesc ? <meta name="twitter:description" content={pageDesc} /> : null}
      <meta name="twitter:image" content={imageUrl} />
      {noindex ? <meta name="robots" content="noindex, nofollow" /> : null}
      {scripts.map((data, i) => (
        <script key={`jsonld-${i}`} type="application/ld+json">
          {JSON.stringify(data)}
        </script>
      ))}
    </Helmet>
  );
}
